import { styled } from '@uhg-abyss/web/tools/styled';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Text } from '@uhg-abyss/web/ui/Text';

export const HeaderContainer = styled('div', {
  backgroundColor: '$bgProviderDetailsColor',
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingTop: '$sm',
  '@media (max-width: 1248px)': {
    paddingLeft: '$lg',
    paddingRight: '$lg',
  },
  '@media (max-width: 464px)': {
    paddingLeft: 0,
    paddingRight: 0,
  },
});

export const HeaderFlex = styled(Flex, {
  '&.abyss-flex-root': {
    marginTop: '0px',
  },
  '@media (max-width: 464px)': {
    paddingRight: '$md',
  },
});

export const HeaderContentWrapper = styled('div', {});

export const HeaderPageDetails = styled('div', {
  backgroundColor: '$bgProviderDetailsColor',
});

export const NavAndShareButton = styled(Button, {
  '&.abyss-button-root': {
    color: '$core.color.brand.100',
    height: 'unset',
    padding: '0',
    '@media (max-width: 464px)': { fontSize: '12.64px', lineHeight: '16px' },
  },
});
export const VoiceOnlyText = styled('p', {
  border: '0',
  clip: 'rect(0 0 0 0)',
  height: '1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  userSelect: 'none',
  width: '1px',
});

export const HeaderIcon = styled(IconSymbol, {
  '&.abyss-icon-symbol': {
    marginRight: '2px',
  },
});
export const DetailsSectionWrap = styled('div', {
  display: 'flex',
  marginTop: '8px',
  '@media (max-width: 984px)': {
    marginTop: '$sm',
  },
  '@media (max-width: 464px)': {
    marginTop: '$md',
    paddingLeft: '16px',
    paddingRight: '32px',
  },
});

export const DetailsHeaderSection = styled('div', {
  '@media (max-width: 464px)': {
    paddingLeft: '16px',
  },
});

export const displayVirtualVisitStyle = {
  'abyss-flex-root': {
    display: 'flex',
    borderRadius: '100px',
    border: '1px solid $core.color.brand.100',
    background: 'white',
    alignItems: 'flex-start',
    padding: '4px',
    position: 'relative',
    top: '-82px',
    left: '60px',
    zindex: 1,
  },
};

export const displayBookMarkIconStyle = {
  padding: '24px 5px 24px 0px',
};

export const DetailsSubSection = styled('div', {
  width: '100%',
  marginLeft: '$md',
});

export const ProviderTitle = styled(Heading, {
  fontFamily: '$primary',
  '@media (max-width: 464px)': {
    '&.abyss-heading-root': {
      fontWeight: 'bold',
      fontSize: '$lg !important',
      lineHeight: '24px !important',
    },
  },
  '&.abyss-heading-root': {
    fontWeight: 'bold',
    fontSize: '22.78px',
    lineHeight: '32px',
  },
});

export const ProviderSubtitleSection = styled(Flex, {
  justifyContent: 'space-between',
  marginTop: '4px',
  '@media (max-width: 464px)': {
    flexDirection: 'column',
  },
});

export const ProviderSubtitle = styled(Text, {
  marginRight: '24px',
  fontFamily: '$primary',
});

export const ProviderIndicatorSection = styled('div', {
  display: 'inline-flex',
  marginTop: '12px',
  '@media (min-width: 745px)': {
    justifyContent: 'flex-start',
  },
  '@media (min-width: 985px)': {
    justifyContent: 'flex-end',
  },
  '@media (max-width: 464px)': {
    justifyContent: 'space-between',
    marginTop: '4px',
  },
});

export const ProviderRatingText = styled(Text, {
  marginLeft: '5px',
});
export const ProviderRatingsText = styled(Text, {
  marginLeft: '5px',
  marginTop: '0px',
  '@media (max-width: 464px)': {
    '&.abyss-text-root': {
      fontSize: '$sm',
      marginTop: '-0.1px',
    },
  },
});

export const ProviderIndicator = styled(Text, {
  fontFamily: '$primary',
  marginLeft: '5px',
});

export const ProviderUpdatedSubsection = styled(Flex, {
  alignItems: 'start',
  color: '$core.color.neutral.0',
  fontSize: '12.64px',
  fontWeight: '$medium',
  lineHeight: '16px',
  marginTop: '$md',
  padding: '0',
});

export const ProviderUpdatedContainer = styled('div', {
  '@media (max-width: 464px)': { marginTop: '2px' },
});

export const SuggestEditLink = styled(Link, {
  '&.abyss-link-root': {
    color: '$core.color.neutral.0',
    fontSize: '12.64px',
    fontWeight: 'bold',
    lineHeight: '16px',
    textDecoration: 'underline',
    marginRight: '$sm',
  },
});

export const YourPCPMessageBox = styled(Alert, {
  '&.abyss-alert-root': {
    '.abyss-alert-container': {
      border: 'none',
      background: '$core.color.aqua.15',
      minHeight: 'unset',
      padding: '9px $sm',
      '.abyss-alert-icon-container': {
        marginRight: '$sm',
      },
      '.abyss-alert-title': {
        fontSize: '12.64px',
        color: '$core.color.brand.100',
        marginRight: 0,
      },
    },
    '.abyss-alert-action-button': {
      border: 'none',
      color: '$core.color.brand.60',
      background: 'none',
      fontSize: '12.64px',
      fontWeight: 'bold',
      height: 'unset',
      padding: '0px',
      margin: '0px',
      '.abyss-icon-symbol': { marginRight: '5px' },
    },
  },
});

export const ChoosePCPButtonContainer = styled(Button, {
  '&.abyss-button-root': {
    backgroundColor: '#D14600',
    fontWeight: '600',
    overflow: 'visible',
    whiteSpace: 'nowrap',
    '.abyss-insert-element-before': {
      paddingRight: '5px !important',
    },
  },
});
export const InteractSection = styled('div', {
  paddingTop: '$lg',
  paddingBottom: '$lg',
  a: {
    padding: '$sm $lg $sm $md',
  },
  '@media (max-width: 464px)': {
    paddingTop: '$md',
    paddingBottom: '$md',
    a: {
      height: '32px',
      display: 'flex',
      padding: '6px $lg 6px $md',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
    },
  },
  display: 'flex',
  gap: '8px',
  overflow: 'auto',
});

export const InteractButton = styled(Button, {
  '&.abyss-button-root': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
    padding: '$sm $md $sm $md',
    overflow: 'visible',
    '@media (max-width: 464px)': {
      height: '32px',
      display: 'flex',
      padding: '6px $md 6px $md',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
    },
  },
  '.abyss-insert-element-root': {
    fontWeight: '600',
    color: '$core.color.brand.100 !important',
    '.abyss-insert-element-after': {
      paddingLeft: '8px',
    },
  },
  '.abyss-insert-element-before': {
    paddingRight: '5px !important',
  },
});

export const AvatarDetailsPage = styled('div', {
  width: '84px',
  height: '84px',
  minWidth: '84px',
  minHeight: '84px',
  borderRadius: '50%',
  overflow: 'hidden',
});

export const DetailTierInfoBox = styled(Box, {
  display: 'flex',
  padding: '2px 8px',
  alignItems: 'center',
  marginTop: '$md',
  marginBottom: '$md',
  gap: '4px',
  borderRadius: '4px',
  '&.abyss-box-root': {
    backgroundColor: '#F2F8E6',
    padding: '$sm',
    minWidth: '128px',
    width: 'fit-content',
    height: '22px',
  },
});

export const LayoutContainer = styled(Layout.Group, {
  gap: '18px',
  margin: '0px, 0px , 8px, 0px',
});
export const YourPCPContainer = styled('div', {
  maxWidth: '390px',
  width: '390px',
  margin: '$lg 0 0 0',
  height: '34px',
  borderRadius: '4px',
  padding: '8px',
  gap: '32px',
  backgroundColor: '$core.color.aqua.15',
  display: 'flex',
  '@media (max-width: 464px)': {
    margin: '$md 0 0 $md',
  },
});

export const YourPCPMessageDetailsContainer = styled('div', {
  lineHeight: '16px',
  gap: '8px',
  display: 'flex',
});

export const CostIndicatorIconStyle = styled('div', {
  '.abyss-icon-symbol': {
    height: '24px',
    width: '24px',
    '@media (max-width: 464px)': {
      height: '20px',
      width: '20px',
    },
  },
});

export const MarginStyle = styled('div', {
  marginRight: '24px',
});

export const BadgeContainer = styled('div', {
  marginBottom: '4px',
  '@media (max-width: 464px)': {
    marginBottom: '-8px',
  },
});

export const PopoverWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
});
export const PCPAlertMessage = {
  '.abyss-alert-container': {
    borderColor: 'white',
    minHeight: '36px !important',
    borderWidth: '0px !important',
    border: 0,
    padding: '8px 8px 8px 0px',
  },
  '.abyss-alert-icon-container': {
    alignItems: 'center',
    height: '20px',
    width: '20px',
  },
  '.abyss-alert-header-text-container': {
    lineHeight: '20px',
    fontSize: '16px',
    fontWeight: '700',
  },
};

export const PCPAlertMessageMobile = {
  '.abyss-alert-container': {
    borderColor: 'white',
    minHeight: '36px !important',
    borderWidth: '0px !important',
    border: 0,
    padding: '0px',
  },
  '.abyss-alert-icon-container': {
    alignItems: 'center',
    height: '16.67px',
    width: '16.67px',
  },
  '.abyss-alert-title': {
    fontSize: '14px',
    alignItems: 'center',
  },
};
export const AlertMessage = {
  backgroundColor: '$core.color.brand.5',
};

export const PCPNotChosenCSS = {
  display: 'flex',
  marginLeft: 'auto',
  paddingTop: '8px',
  paddingBottom: '8px',
  paddingRight: 'calc(50% - 600px)',
  paddingLeft: 'calc(50% - 600px)',
  border: '1px solid $core.color.brand.60',
  borderRadius: '4px',
  backgroundColor: '$core.color.brand.5',
  '@media (max-width: 984px)': {
    padding: '8px 8px 8px 24px',
  },
  '@media (max-width: 984px)': {
    padding: '8px 8px 8px 12px',
    minHeight: '56px',
    alignItems: 'start',
  },
};

export const PCPNotChosenContentCSS = {
  gap: '16px',
  display: 'flex',
  alignItems: 'center',
  '@media (max-width: 984px)': {
    flexDirection: 'column',
    width: 'auto',
    gap: '4px',
    alignItems: 'start',
  },
};

export const StyledPCPNotChosenHeader = styled('div', {
  fontWeight: '700',
  fontSize: '16px',
  lineHeight: '20px',
  color: '#323333',
  '@media (max-width: 984px)': {
    fontSize: '$md',
  },
});

export const StyledPCPNotChosenText = styled('div', {
  fontSize: '14px',
  fontWeight: '400',
  font: 'Enterprise Sans VF',
  color: '#323334',
  lineHeight: '18px',
  '@media (max-width: 984px)': {
    fontSize: '$sm',
  },
});

export const PCPNotChosenButtonCSS = {
  'abyss-button-root': {
    height: '20px',
    paddingLeft: '0x',
    paddingRight: '0x',
    fontSize: '14px',
    fontWeight: '700',
    font: 'Enterprise Sans VF',
    fontColor: '$core.color.brand.60',
    lineHeight: '18px',
    '@media (max-width: 984px)': {
      fontSize: '$sm',
    },
  },
};

export const AlertStyling = {
  '.abyss-alert-title': {
    lineHeight: '20px',
    marginTop: '2px',
    color: '#323333',
  },
  '.abyss-alert-container': {
    height: '52px',
    borderWidth: '1px 0px 1px 0px',
  },
  '.abyss-alert-header-container': {
    marginLeft: 'auto',
    maxWidth: '1200px',
    marginRight: 'auto',
    alignItems: 'center',
  },
  '.abyss-icon-symbol ': {
    fontSize: '20px !important',
    paddingTop: '2px',
  },
  '.abyss-alert-children-container': {
    paddingTop: '2px',
    lineHeight: '18px',
    fontSize: '14px',
    fontWeight: '400',
    color: '#323333',
  },
  '.abyss-alert-icon-container': {
    marginRight: '4px',
  },
  '.abyss-alert-header-text-container': {
    flexDirection: 'row',
    '@media (max-width: 593px)': {
      flexDirection: 'column',
    },
    '@media (max-width: 464px)': {
      flexDirection: 'column',
    },
  },
};

export const LimitedProviderBannerStyling = {
  '.abyss-alert-container': {
    borderLeft: 'none',
    borderRight: 'none',
    borderRadius: 0,
  },
  '.abyss-alert-header-text-container': { flexDirection: 'columns' },
  '.abyss-alert-icon': { fontSize: '22px' },
  '.abyss-alert-title': { color: '#323333' },
  '.abyss-alert-children-container': { color: '#323333' },
};

export const StyledViewIdBannerBox = styled(Box, {
  border: 'solid $core.color.brand.60',
  borderRadius: '4px',
  borderWidth: '1px 1px 1px 4px',
  margin: '-16px 0 8px 0',
});

export const StyledViewIdBannerFlex = styled(Flex, {
  '>button': {
    padding: '0 16px',
    marginLeft: '8px',
    width: '131px',
  },
  '>span': {
    margin: '0 8px',
  },
  '>svg': {
    marginRight: '-4px',
  },

  '@media (max-width: 464px)': {
    button: {
      marginLeft: '24px',
    },
    '>span': {
      margin: '2px 0',
    },
    '>span:nth-of-type(3)': {
      marginLeft: '24px',
    },
    '>svg': {
      marginRight: '4px',
    },
  },
});
